// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../shared/localize'
import type { AutomatedRulesLog } from './types'

import { Table, HeaderCell, HeaderRow } from '../components/MainTable'
import Button from './controls/SmallRoundedButton'
import Row from './AutomatedRulesLogsTable/Row'

type Props = {|
  logs: Array<AutomatedRulesLog>
|}

const AutomatedRulesPath = '/automated_rules'
const t = translateFunc(translations.automated_rules_logs_table)

export default class AutomatedRulesTable extends Component<Props> {
  table: any

  render() {
    return (
      <div>
        <Button href={AutomatedRulesPath}>{t('back')}</Button>
        <Table
          ref={(el) => {
            this.table = el
          }}
        >
          <thead>
            <HeaderRow>
              <HeaderCell alignLeft>{t('header.logged_at')}</HeaderCell>
              <HeaderCell alignLeft>{t('header.rule')}</HeaderCell>
              <HeaderCell alignLeft>{t('header.owner')}</HeaderCell>
              <HeaderCell alignLeft>{t('header.message')}</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody>
            {this.props.logs.map((log) => (
              <Row key={log.id} log={log} />
            ))}
          </tbody>
        </Table>
      </div>
    )
  }
}
